import LocatorApi from '@/lib/LocatorApi';
export default async function placesSearchAtoZLoader() {
    const materials = LocatorApi.getInstance().get('materials');
    return { materials };
}
